import { render, staticRenderFns } from "./PaymentMethodActionDelete.vue?vue&type=template&id=dcbc0046&"
import script from "./PaymentMethodActionDelete.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodActionDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports